<template>
            <el-table ref="table" :data="rows" size="mini" max-height="430" border stripe
                :row-class-name="actions.genMultiRowClass">
                <el-table-column type="index" label="#" width="44" align="center" />
                <el-table-column prop="parent" label="本地父体" min-width="125" show-overflow-tooltip />
                <el-table-column label="本地品名" width="160">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.pm || '未识别品名'" placement="top" :open-delay="300">
                            <div class="gen-multi-product-name">{{ scope.row.pm || '未识别品名' }}</div>
                        </el-tooltip>
                        <div v-if="actions.genMultiRowIssue(scope.row)" class="gen-sku-error-message">{{ actions.genMultiRowIssue(scope.row) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="shop" label="店铺" width="90" />
                <el-table-column label="关联 SKU" width="130">
                    <template slot="header">
                        <span>关联 SKU</span>
                        <el-button v-if="failedSkuCount" type="text" size="mini" style="padding:0;margin-left:4px;"
                            @click.stop="actions.retryGenMultiSkuDetails">
                            重试失败项<span v-if="failedSkuCount">（{{ failedSkuCount
                            }}）</span>
                        </el-button>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="procurement" style="font-size:12px;color:#606266;">{{ scope.row.sku || '—' }}</span>
                        <template v-else>
                        <!-- 不论关联 SKU 数量，均展示 SKU | ERP 品名的下拉选项。 -->
                        <div v-if="(asin || actions.genRowShouldPair(scope.row)) && scope.row.skus && scope.row.skus.length"
                            class="gen-sku-select-wrap">
                            <el-select v-model="scope.row.sku" filterable size="mini" style="width:100%;"
                                :class="scope.row._skuError || scope.row.resolveError || scope.row.sku_detail_error ? 'gen-sku-error' : ''"
                                placeholder="请选择 SKU" @change="actions.onGenRowSkuChange(scope.row)">
                                <el-option v-for="sku in scope.row.skus" :key="sku"
                                    :label="String(sku || '').trim()" :value="sku">
                                    <span class="gen-sku-option-label">{{ actions.genSkuOptionLabel(scope.row, sku) }}</span>
                                </el-option>
                            </el-select>
                        <div v-if="actions.isGenSkuDetailLoading(scope.row)" class="gen-sku-loading-mask"
                                title="正在获取 SKU 品名">
                                <i class="el-icon-loading"></i>
                                <span>加载中</span>
                            </div>
                        </div>
                        <el-input v-else-if="(asin || actions.genRowShouldPair(scope.row))" v-model="scope.row.sku" size="mini"
                            maxlength="128"
                            :class="scope.row._skuError || scope.row.resolveError || scope.row.sku_detail_error ? 'gen-sku-error' : ''"
                            placeholder="请输入 SKU" @input="actions.onGenRowSkuInput(scope.row)"
                            @change="actions.onGenRowSkuChange(scope.row)" @blur="actions.loadGenRowSkuDetail(scope.row)" />
                        <span v-else-if="scope.row.sku" style="font-size:12px;color:#606266;">{{ scope.row.sku }}</span>
                        <span v-else style="font-size:12px;color:#909399;">不需要</span>
                        <div v-if="scope.row.resolveError || scope.row.sku_detail_error" class="gen-sku-error-message"
                            :title="scope.row.resolveError || scope.row.sku_detail_error">{{ scope.row.resolveError || scope.row.sku_detail_error }}</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="后缀" width="72" align="center">
                    <template slot-scope="scope">
                        <span v-if="procurement" style="font-size:12px;color:#606266;">T</span>
                        <template v-else>
                        <el-input v-model="scope.row.suffix" size="mini" maxlength="6" placeholder="T"
                            :class="scope.row.suffixError ? 'gen-sku-error' : ''"
                            @change="actions.onGenRowSuffixChange(scope.row)" />
                        <div v-if="scope.row.suffixError" class="gen-sku-error-message">
                            {{ scope.row.suffixError }}
                        </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="创建后配对" width="96" align="center">
                    <template slot-scope="scope">
                        <span v-if="procurement" class="gen-multi-pair-control is-enabled">是</span>
                        <template v-else>
                        <div class="gen-multi-pair-control">
                            <el-switch v-model="scope.row.should_pair" :width="32" aria-label="创建后配对"
                                @change="actions.onGenRowPairChange(scope.row)" />
                            <span :class="{ 'is-enabled': scope.row.should_pair }">{{ scope.row.should_pair ? '是' : '否' }}</span>
                        </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="生成模式" width="116" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.mode" size="mini" style="width:100%;" aria-label="生成模式"
                            :disabled="busy" @change="actions.onGenRowModeChange(scope.row)">
                            <el-option label="按模板" value="template" />
                            <el-option label="按属性" value="attribute" />
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="MSKU颜色" :width="asin ? 230 : 170">
                    <template slot-scope="scope">
                        <!-- 品名配置色与本次上传色冲突时红框提示，并要求用户明确选一个来源 -->
                        <div :class="{ 'gen-color-conflict': asin && scope.row.color_conflict }">
                            <el-input v-model="scope.row.msku_color" size="mini" placeholder="必填" :disabled="busy"
                                @input="actions.onGenRowColorChange(scope.row)" />
                        </div>
                        <template v-if="asin && scope.row.color_conflict">
                            <el-select v-model="scope.row.color_source" size="mini" style="width:100%;margin-top:4px;"
                                :disabled="busy" aria-label="颜色来源"
                                @change="actions.onGenRowColorSourceChange(scope.row)">
                                <el-option :label="'品名配置：' + scope.row.config_msku_color" value="config" />
                                <el-option :label="'本次上传：' + scope.row.row_msku_color" value="row" />
                            </el-select>
                            <div class="gen-color-conflict-hint">
                                原品名已有 MSKU 颜色配置「{{ scope.row.config_msku_color }}」，请选择本次使用哪个
                            </div>
                        </template>
                    </template>
                </el-table-column>
                        <el-table-column v-if="asin" label="产品类型" min-width="190">
                            <template slot="header">
                                <span>产品类型</span>
                                <el-select :value="batchProductType" filterable clearable size="mini"
                                    placeholder="批量选择产品类型" style="width:100%;" :disabled="busy"
                                    @change="$emit('batch-product-type', $event)">
                                    <el-option v-for="pt in productTypes" :key="pt.value" :label="pt.label" :value="pt.value" />
                                </el-select>
                            </template>
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.product_type_choice" filterable clearable size="mini"
                                    style="width:100%;" placeholder="选择产品类型" :disabled="busy"
                                    @change="actions.onBatchAsinProductTypeChange(scope.row)">
                                    <el-option v-for="pt in productTypes" :key="pt.value" :label="pt.label" :value="pt.value" />
                                </el-select>
                                <div class="batch-asin-product-type-hint">
                                    {{ scope.row.product_type_source ? '来源：' + scope.row.product_type_source : '来自品名/父体配置' }}
                                </div>
                                <div class="batch-asin-product-type-hint">本批次须统一产品类型</div>
                            </template>
                        </el-table-column>
                <el-table-column label="基础名预览" min-width="300">
                    <template slot-scope="scope">
                        <div v-if="scope.row._baseEditing" style="display:flex;align-items:center;gap:4px;">
                            <el-input v-model="scope.row._baseDraft" size="mini" maxlength="255" placeholder="编辑基础名" :disabled="busy"
                                @keyup.enter.native="actions.saveGenRowBaseEdit(scope.row)"
                                @keydown.esc.native.stop="$set(scope.row, '_baseEditing', false)" />
                            <el-button type="primary" size="mini" icon="el-icon-check" :disabled="busy"
                                aria-label="保存基础名" @click="actions.saveGenRowBaseEdit(scope.row)" />
                        </div>
                        <div v-else
                            :style="{ fontSize: '12px', wordBreak: 'break-all', fontWeight: actions.genRowOverlong(scope.row) ? 'bold' : 'normal' }"
                            :class="actions.genRowOverlong(scope.row) ? 'gen-base-warn' : 'gen-base-ok'">
                            <span>{{ actions.genRowBase(scope.row) || '-' }}</span>
                            <el-button type="text" size="mini" style="padding:0;margin-left:4px;" :disabled="busy"
                                @click="actions.startGenRowEdit(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.base_override" type="text" size="mini" style="padding:0;margin-left:4px;" :disabled="busy"
                                title="手动基础名仅用于本次生成；恢复后按当前规则自动预览"
                                @click="actions.resetGenRowBase(scope.row)">恢复自动</el-button>
                        </div>
                        <div v-if="actions.genRowOverlong(scope.row)" style="font-size:11px;color:#CC0000;">
                            超出最大 {{ scope.row.max_base_len }} 字符，将截断为「{{
                                (actions.genRowBase(scope.row) || '').slice(0, scope.row.max_base_len || 0) }}」
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" width="85">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.supplier" size="mini" placeholder="SKU详情带出/手填" :disabled="busy"
                                @input="actions.onGenRowSupplierChange(scope.row)" />
                    </template>
                </el-table-column>
                <el-table-column label="国家代码" width="80">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.country" size="mini" maxlength="2" placeholder="US" :disabled="busy"
                            @input="actions.onGenRowCountryChange(scope.row)" />
                    </template>
                </el-table-column>


                <el-table-column label="数量" width="80" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-if="procurement" style="font-size:12px;color:#606266;">{{ scope.row.num || 0 }}</span>
                        <template v-else>
                        <el-input-number v-model="scope.row.num" :min="1" :max="200" :precision="0" size="mini" :controls="false" style="width:100%" @change="actions.quantityChange(scope.row)" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="96" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" :disabled="busy"
                            @command="command => actions.onGenMultiRowCommand(command, scope.row)">
                            <el-button size="mini" :disabled="busy" class="gen-multi-row-action">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" class="gen-multi-row-menu">
                                <el-dropdown-item command="config" icon="el-icon-setting">配置品名规则</el-dropdown-item>
                                <el-dropdown-item v-if="asin" command="parentConfig" icon="el-icon-s-operation">配置父体规则</el-dropdown-item>
                                <el-dropdown-item v-if="!procurement" command="remove" icon="el-icon-delete" divided
                                    class="gen-multi-remove-action">移除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
</template>

<script>
// Both workflows edit the same generation columns; actions preserve their submission boundaries.
export default {
    name: 'MskuGenerationTable',
    props: {
        rows: { type: Array, default: () => [] },
        asin: Boolean,
        busy: Boolean,
        actions: { type: Object, required: true },
        productTypes: { type: Array, default: () => [] },
        batchProductType: { type: String, default: '' },
        failedSkuCount: { type: Number, default: 0 },
        // Procurement keeps parent/shop/SKU/warehouse/suffix/pairing fixed;
        // the same table still exposes the shared naming and product-type
        // configuration columns.
        procurement: Boolean,
    },
    methods: {
        doLayout() { if (this.$refs.table) this.$refs.table.doLayout(); },
    },
};
</script>
<style scoped>
/* 品名配置色与本次上传色冲突：红框 + 红字提示，要求用户明确选择颜色来源 */
.gen-color-conflict {
    border: 1px solid #F56C6C;
    border-radius: 4px;
    padding: 2px;
}

.gen-color-conflict-hint {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1.3;
    margin-top: 2px;
}

.gen-multi-product-name {
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gen-multi-pair-control {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #909399;
    white-space: nowrap;
}

.gen-multi-pair-control .is-enabled {
    color: #409eff;
}

.gen-multi-row-action {
    padding: 7px 10px;
}

.gen-base-ok {
    color: #409eff;
}

.gen-base-warn {
    color: #CC0000;
    background: #fef0f0;
    border-radius: 3px;
    padding: 1px 4px;
}

.gen-sku-error ::v-deep .el-input__inner {
    border-color: #F56C6C;
}

.gen-sku-select-wrap {
    position: relative;
    display: inline-flex;
    width: 100%;
}

.gen-sku-loading-mask {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #409EFF;
    font-size: 11px;
    background: rgba(255, 255, 255, 0.78);
    border-radius: 4px;
    cursor: wait;
}

.gen-sku-loading-mask .el-icon-loading {
    font-size: 14px;
}

.gen-sku-error-message {
    color: #F56C6C;
    font-size: 11px;
    line-height: 16px;
    word-break: break-all;
}


.batch-asin-product-type-hint { color: #909399; font-size: 11px; }
</style>
